import { useEffect } from 'react';

const SUFFIX = 'Alhudah';

/**
 * Set the document title for the lifetime of a route.
 *
 * `title` is composed as `"<title> · Alhudah"` when provided; passing
 * `null` or `undefined` resets to the site default.
 *
 * Restores the previous title on unmount — useful for nested routes
 * that pop back to an outer view.
 */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} · ${SUFFIX}` : SUFFIX;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
